import { defineSlotRecipe as e } from "@pandacss/dev";
import { anatomy as r } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/slider/dist/index.mjs";
const t = e({
  className: "slider",
  slots: r.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "4"
    },
    control: {
      position: "relative",
      display: "flex",
      alignItems: "center"
    },
    track: {
      backgroundColor: "bg.emphasized",
      borderRadius: "full",
      overflow: "hidden",
      flex: "1",
      height: "4px"
    },
    range: {
      background: "base.black"
    },
    thumb: {
      background: "neutral.100",
      borderColor: "neutral.200",
      borderRadius: "full",
      boxShadow: "0px 1px 16px 0px rgba(0, 0, 0, 0.06)",
      outline: "none",
      zIndex: "1",
      height: "24px",
      width: "24px"
    },
    label: {
      color: "fg.default",
      fontWeight: "medium"
    },
    markerGroup: {
      marginTop: "-1"
    },
    marker: {
      "--before-background": {
        base: "white",
        _dark: "colors.colorPalette.fg"
      },
      color: "bg-primary",
      _before: {
        background: "white",
        borderRadius: "full",
        content: "''",
        display: "block",
        left: "50%",
        position: "relative",
        transform: "translateX(-50%)"
      },
      _underValue: {
        _before: {
          background: "var(--before-background)"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  },
  variants: {
    size: {
      md: {
        label: {
          fontSize: "lg",
          letterSpacing: "lg"
        },
        track: {
          height: "3px"
        },
        thumb: {
          height: "24px",
          width: "24px"
        }
      },
      lg: {
        label: {
          fontSize: "lg",
          letterSpacing: "lg"
        },
        track: {
          height: "10px"
        },
        thumb: {
          height: "24px",
          width: "24px"
        }
      }
    },
    type: {
      primary: {
        track: {
          backgroundColor: "primary.500"
        },
        thumb: {
          backgroundColor: "neutral.100",
          borderColor: "primary.500"
        }
      }
    }
  }
});
export {
  t as slider
};
